import john from "../assets/attorneys/att.jpg";
import james from "../assets/attorneys/DSC07907t.png";
import kristen from "../assets/attorneys/KristenCampos.png";
import maria from "../assets/attorneys/MARIA FISCHER.png";
import robert from "../assets/attorneys/Robert.png";
import sam from "../assets/attorneys/Sam.png";
import vejay from "../assets/attorneys/VeJay+Vicino+C.png";
import vesna from "../assets/attorneys/Vesna.png";
import mark from "../assets/attorneys/mark.png";

export const attorneys = [
  {
    id: "john-wilson",
    name: "John Wilson",
    role: "Senior Associate",
    image: mark,
    details: {
      email: "john.wilson@libertyjusticeadvocate.com",
      location: "Providing legal support to families nationwide",
      title: "Family & Inheritance Attorney",
      firm: "Liberty & Justice advocates ",
      bio: `Hello, I’m John Wilson, a dedicated Family and Inheritance Law specialist at Liberty & Justice Advocates. My mission is to help families find clarity and justice during difficult times.
\n\nI work with families on everything from child custody and divorce proceedings to inheritance claims and property disputes. With a clear, compassionate, and professional approach, I ensure my clients feel heard and protected.`,
      services: [
        "Claiming life insurance and estate benefits",
        "Understanding and reviewing wills",
        "Probate court guidance",
        "Conflict resolution among beneficiaries",
        "Legal representation for rightful heirs",
      ],
      whyChooseMe: `I bring years of trusted experience in family law and inheritance disputes. My practice is built on integrity, clarity, and strong results. Every case is personal, and I take the time to truly understand your needs.`,
    },
  },
  {
    id: "mark",
    name: "Mark A. Krasner, Esq.",
    role: "Family & Inheritance Attorney",
    image: john,
    details: {
      phone: "(772) 269-7953",
      email: "mark.krasner@libertyjusticeadvocate.com",
      
      title: "Family & Inheritance Attorney",
      firm: "Liberty & Justice Advocates",
      about: [
        "Mark A. Krasner is a principal attorney at Liberty & Justice Advocates dedicated to family law and inheritance matters. He helps clients protect their families, resolve disputes with clarity, and secure what they are entitled to under wills, trusts, and California law.",
        "His practice focuses on divorce and custody, spousal and child support, property division, probate and estate administration, will contests, beneficiary disputes, and planning that keeps assets in the right hands for the next generation.",
        "Mark has been Martindale-Hubbell AV rated preeminent for 16 consecutive years and recognized as a Top Attorney in San Diego. He combines strong courtroom advocacy with a compassionate, practical approach so clients feel supported through emotionally difficult transitions.",
        "Outside of work, Mark enjoys travel and golf. His philosophy is Learn, Earn & Return — giving back to the families and communities he serves.",
      ],
      barsAndCourts: [
        "California Bar",
        "New York Bar",
        "Washington, DC Bar",
        "U.S. District Court, Northern District of California",
        "U.S. District Court, Southern District of California",
        "U.S. Supreme Court",
      ],
      education: [
        "University of San Diego, School of Law, JD, Magna Cum Laude",
        "San Diego State University, BS Accounting, Summa Cum Laude",
      ],
      practiceAreas: [
        "Family Law & Divorce",
        "Child Custody & Support",
        "Spousal Support & Property Division",
        "Inheritance & Beneficiary Disputes",
        "Probate & Estate Administration",
        "Wills, Trusts & Estate Planning",
        "Life Insurance & Estate Claims",
      ],
      representativeTransactions: [
        "Resolved high-conflict custody and property disputes for families with complex assets and business interests.",
        "Represented heirs in contested probate matters and secured favorable distributions under disputed wills.",
        "Guided clients through probate administration, creditor claims, and timely distribution to beneficiaries.",
        "Negotiated marital settlement agreements protecting parental rights and long-term financial stability.",
        "Assisted families with life insurance claims, missing benefits, and disputes among multiple beneficiaries.",
        "Structured estate plans—including trusts and healthcare directives—to reduce conflict among surviving family members.",
        "Advocated for clients in will contests and claims involving undue influence or improper estate documents.",
        "Coordinated family law and estate matters where divorce, support, and inheritance issues overlapped.",
      ],
      professionalAffiliations: [
        "Board Member, National Council of Juvenile and Family Court Judges",
        "American Bar Association — Family Law Section",
        "San Diego County Bar Association",
        "La Jolla Bar Association",
        "Foothills Bar Association",
        "Estate Planning Council of San Diego",
        "California Trusts, Estates and Probate Section",
      ],
      communityAffiliations: [
        "Board Member, Big Brother Big Sister of Northern Nevada",
        "Jewish Family Services",
        "Promises 2 Kids",
        "YWCA of San Diego County (Domestic Violence Awareness & Prevention)",
        "Ronald McDonald House Charities Northern Nevada, Former Board Member",
        "Parasol Tahoe Community Foundation",
        "Scripps Memorial Hospital",
      ],
      publications: [
        "Contributing author, family law and estate planning guidance for families",
        "Executive Spotlight “Top Lawyers: The Secrets to Their Success,” Worldwide Publishing",
      ],
      speakingEngagements: [
        "“Protecting Your Children and Assets in Divorce,” National Law Foundation",
        "“Recent Developments in California Family Law,” National Law Foundation",
        "“Estate Planning Basics for Families,” Foothills Bar Association",
        "“Probate and Inheritance: What Heirs Need to Know,” San Diego County Bar Association",
        "“Avoiding Conflict Among Beneficiaries,” Estate Planning Council Seminar",
        "“Life Insurance and Estate Claims,” community legal education workshop",
      ],
    },
  },
  {
    id: "james-reynolds",
    name: "James Reynolds",
    role: "Managing Partner",
    image: james,
    details: {
      email: "james.reynolds@libertyjusticeadvocate.com",
      location: "New York, NY",
      title: "Managing Partner",
      firm: "Liberty & Justice Advocates",
      bio: `As Managing Partner, I oversee our firm's strategic direction and ensure we continue to provide high-caliber legal services across all practice areas. I work closely with our attorneys to maintain excellence in client outcomes.`,
      services: [
        "Leadership & legal team management",
        "Strategic case oversight",
        "Client relationship management",
        "Legal compliance and policy review",
        "Partnership and expansion strategy",
      ],
      whyChooseMe: `With over two decades of legal experience and a results-driven mindset, I lead with purpose, ensuring every client and case receives the attention and resources needed to succeed.`,
    },
  },
  {
    id: "kristen-campos",
    name: "Shatira Danner",
    role: "Head of Finance",
    image: kristen,
    details: {
      email: "Sharita.Danner@libertyjusticeadvocate.com",
      location: "Los Angeles, CA",
      title: "Head of Finance",
      firm: "Liberty & Justice Advocates",
      bio: `I’m Shatira Danner, Head of Finance at Liberty & Justice Advocates. I oversee the firm’s financial operations, including budgeting, financial reporting, and billing coordination. My focus is on maintaining accurate records, supporting responsible financial planning, and making financial information clear and accessible. I work closely with our team to keep day-to-day operations running smoothly and help clients understand their billing questions with professionalism and care.`,
      services: [
        "Financial planning and budget oversight",
        "Financial reporting and record management",
        "Client billing coordination and invoice inquiries",
        "Expense tracking and cash flow management",
        "Coordination with the firm’s accounting team",
      ],
      whyChooseMe: `My approach to finance is grounded in accuracy, transparency, and discretion. I aim to provide clear communication about billing and thoughtful financial oversight that supports our team and the clients we serve.`,
    },
  },
  {
    id: "maria-fischer",
    name: "Maria Fischer",
    role: "Immigration Specialist",
    image: maria,
    details: {
      email: "maria.fischer@libertyjusticeadvocate.com",
      location: "Houston, TX",
      title: "Immigration Law Attorney",
      firm: "Liberty & Justice Advocates",
      bio: `Hi, I'm Maria Fischer, committed to guiding individuals and families through the complex immigration process. Whether you're seeking asylum, residency, or work authorization — I’m here to help.`,
      services: [
        "Visa and green card applications",
        "Deportation defense",
        "Family-based immigration",
        "Work and student visas",
        "Citizenship and naturalization assistance",
      ],
      whyChooseMe: `With a deep understanding of immigration law and an unwavering dedication to justice, I offer personalized legal solutions to help you start your next chapter in the U.S.`,
    },
  },
  {
    id: "robert-hayes",
    name: "Robert Hayes",
    role: "Litigation Counsel",
    image: robert,
    details: {
      email: "robert.hayes@libertyjusticeadvocate.com",
      location: "Chicago, IL",
      title: "Civil Litigation Counsel",
      firm: "Liberty & Justice Advocates",
      bio: `As a trial attorney with years of courtroom experience, I represent individuals and businesses in high-stakes civil disputes. My approach combines strategic planning with aggressive advocacy.`,
      services: [
        "Commercial and civil litigation",
        "Contract disputes",
        "Class action representation",
        "Employment litigation",
        "Alternative dispute resolution",
      ],
      whyChooseMe: `I thrive under pressure and fight fiercely for justice in every courtroom battle. My clients rely on my precision and persistence to drive outcomes in their favor.`,
    },
  },
  {
    id: "samuel-blake",
    name: "Samuel Blake",
    role: "Criminal Defense Attorney",
    image: sam,
    details: {
      email: "samuel.blake@libertyjusticeadvocate.com",
      location: "Miami, FL",
      title: "Criminal Defense Attorney",
      firm: "Liberty & Justice Advocates",
      bio: `My name is Samuel Blake, and I defend the accused. From misdemeanors to felonies, I stand between my clients and the full force of the justice system, ensuring their rights are protected.`,
      services: [
        "DUI and traffic defense",
        "Drug and weapons charges",
        "White-collar crime defense",
        "Juvenile criminal cases",
        "Post-conviction relief",
      ],
      whyChooseMe: `I believe every person deserves a fierce advocate — someone who doesn't back down. I’m here to listen, fight, and win with integrity and skill.`,
    },
  },
  {
    id: "vejay-vicino",
    name: "VeJay Vicino",
    role: "Corporate Law Advisor",
    image: vejay,
    details: {
      email: "vejay.vicino@libertyjusticeadvocate.com",
      location: "San Francisco, CA",
      title: "Corporate Law Advisor",
      firm: "Liberty & Justice Advocates",
      bio: `I'm VeJay Vicino, and I specialize in helping startups, mid-size businesses, and large enterprises navigate corporate law. From mergers to compliance, I make legal strategy a business asset.`,
      services: [
        "Business formation and structuring",
        "Contract drafting and negotiation",
        "Mergers and acquisitions",
        "Compliance and governance",
        "Intellectual property strategy",
      ],
      whyChooseMe: `I combine legal expertise with a strong business acumen. My goal is to not just protect — but empower — your business with every legal decision.`,
    },
  },
  {
    id: "vesna-markovic",
    name: "Vesna Markovic",
    role: "Estate Planning Attorney",
    image: vesna,
    details: {
      email: "vesna.markovic@libertyjusticeadvocate.com",
      location: "Denver, CO",
      title: "Estate Planning Attorney",
      firm: "Liberty & Justice Advocates",
      bio: `I’m Vesna Markovic, an estate planning attorney passionate about helping individuals and families secure their legacies. I turn complex estate matters into clear, customized plans.`,
      services: [
        "Wills and trusts drafting",
        "Power of attorney and healthcare directives",
        "Estate tax planning",
        "Guardianship arrangements",
        "Business succession planning",
      ],
      whyChooseMe: `Estate planning doesn’t have to be intimidating. I offer approachable, knowledgeable guidance to give you peace of mind about the future.`,
    },
  },
];
